function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeleb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441,207.67c-8-30.66-21.31-59.24-35.23-78.85C372.25,81.7,294.45,61,240.7,80.7c-45.8,16.82-61.84,67.68-101.84,92-36.81,22.4-70.21,40.67-83.09,83.38-27.19,90.23,80.35,162.16,160.71,139.27,25.36-7.22,46.8-22.42,73.85-22.51,54.88-.19,74.21,7.34,118.61-22.31C452.69,321.36,455,261.35,441,207.67Z",
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,207.67c-8-30.66-21.31-59.24-35.23-78.85C372.25,81.7,294.45,61,240.7,80.7c-45.8,16.82-61.84,67.68-101.84,92-36.81,22.4-70.21,40.67-83.09,83.38-27.19,90.23,80.35,162.16,160.71,139.27,25.36-7.22,46.8-22.42,73.85-22.51,54.88-.19,74.21,7.34,118.61-22.31C452.69,321.36,455,261.35,441,207.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-171"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "418.42 291.4 414.18 291.4 222.71 291.4 218.47 291.4 218.47 299.88 222.71 299.88 222.71 386.08 414.18 386.08 414.18 299.88 418.42 299.88 418.42 291.4",
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.42 291.4 414.18 291.4 222.71 291.4 218.47 291.4 218.47 299.88 222.71 299.88 222.71 386.08 414.18 386.08 414.18 299.88 418.42 299.88 418.42 291.4",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,336.45h52.22V308.54H227.83Zm1.06-26.85H279v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,336.45h52.22V308.54H292.69Zm1.06-26.85h50.1v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.54,308.54v27.91h52.22V308.54Zm51.16,26.85H358.6V309.6h50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,373.89h52.22V346H227.83ZM228.89,347H279v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,373.89h52.22V346H292.69ZM293.75,347h50.1v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.54,373.89h52.22V346H357.54ZM358.6,347h50.1v25.79H358.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.5,
    cy: 322.85,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.04,
    cy: 322.85,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.46,
    cy: 322.85,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,357.11c-4.68,0-8.48,1.43-8.48,3.18s3.8,3.18,8.48,3.18,8.48-1.42,8.48-3.18S259.18,357.11,254.5,357.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,357.11c-4.68,0-8.48,1.43-8.48,3.18s3.8,3.18,8.48,3.18,8.48-1.42,8.48-3.18S323.73,357.11,319,357.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.46,357.11c-4.69,0-8.48,1.43-8.48,3.18s3.79,3.18,8.48,3.18,8.48-1.42,8.48-3.18S390.14,357.11,385.46,357.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.41,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.41,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.22,193.58s0,3.37-7-2.14-8.27-10.71,1.53-16.53c7.52-4.47,19.58-6.07,25.93,1.37,4.84,5.67,4.93,14.49,10.2,19.75,4.89,4.9,16.22,6.13,20.81,16.84s-3.06,8.88.31,19.6,12.25,11.32,6.73,22-15.3,17.45-30.3,10.71-10.72-17.45-20.51-23.88C343.57,229.33,341.13,210.74,354.22,193.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.42,202.77a25.68,25.68,0,0,0-1.75,13.76",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,180.34c1.44,2.73,4.59,6.66,11.54,10.35,12.33,6.56,17,8.49,17,8.49",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,176.81a5.91,5.91,0,0,0,.25,1.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,214.77a6.77,6.77,0,0,1,.35,2.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,193.28s3.69,3.2,12.95,7.05c6.81,2.84,13.62,7.35,16.59,12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,173.73s-6.69.09-2.57,8.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,196.86a93.74,93.74,0,0,0,9.64,11.57c5.4,5.4,4.63,11.57,3.47,14.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,311.76s-9.18,23-10.71,32.14-3.18,21.34-5.24,27.19c-2.63,7.45-6.4,11.39-6.09,14.14s7.65,10.72,4.9,12.86-8.27-7.65-8-13.16,4.28-20.82,4.9-30.31-1.53-23.58-.31-31.84,3.06-15.31,3.06-15.31S387.59,302.57,394.63,311.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,314.51s8.58,11.33,10.72,21.43a74.11,74.11,0,0,0,13.47,28.47c5.82,7.35,10.63,20.7,10.63,20.7s-.61,10.1.61,13.16,4.59.61,4.9-4.29-2-11.07-3.25-14.13-4.93-20-8-29.52-5.82-21.12-8.27-27.55-5.81-14.39-5.81-14.39S374.43,306.86,375.34,314.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.73,225.73l-.91,6.43S387,246.85,387,252.06s7,16.53,8.57,32.76-.92,26.94-.92,26.94c-15-3.06-19.29,2.75-19.29,2.75s-13.16-16.22-15-26.63,2.76-21.13,3.37-29.39-4.59-14.7-9.49-24.19-5.2-19.59.31-20.51,13.47-.31,13.47-.31,12.55.92,18.06,2.45,5.82,4.6,5.82,4.6",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.55,272.16s10.62,16.44,14.38,28.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,266.68s8.56,8.22,11.64,14.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,208s3.37,7.35,3.37,8.58,6.43,7.34,8.57,5.81.61-5.2-.92-8.57-4.59-8.88-4.59-8.88A8.89,8.89,0,0,1,363.1,208Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,182.26l-4.6,10.1s3.06,8.88,6.43,13.16,8,4.6,10.41,3.07c4.74-3,2.45-15.31,2.45-15.31S356.67,188.07,355.45,182.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,216.55a126.26,126.26,0,0,1,14.21,8.34c5.62,3.86,20,19.19,17.91,23.17s-26.86,18-28.39,18-3.42-2-3.42-2-2.19-3.05-3.41-3.05.86-2.86,2.69-3.78,4.67,5.57,4.67,5.57,14.65-14.52,15.57-17.59-22.28-13.4-22.28-13.4",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,244.3l.54-7.64a4.22,4.22,0,0,0,3.91-3.9l.4-5.71-8.42-.6-.4,5.71a4.2,4.2,0,0,0,3.31,4.41l-.55,7.64-4.21-.3-.09,1.36,9.62.68.1-1.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.53,213.79s-8,1.53-7.66,8.27-1.22,42.86,1.84,43.78,29.7-22.35,29.7-22.35,5.81,1.83,7,1.22.92-2.14,1.83-4.59,1.84-2.76-2.44-2.45c-1.9.14-4.78-.13-6.46,1-2.77,1.81-4.38,4.72-7.28,6.59q-5.69,3.65-11.65,6.87c-6,3.22-3.72-9.58-3.44-12.39.4-4.16.94-8.32,1.58-12.45",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,237.67c-1.9.14-4.78-.13-6.46,1-2.77,1.81-4.38,4.72-7.28,6.59q-5.69,3.65-11.65,6.87c-5.35,2.89-4.09-7.11-3.58-11.23a21.94,21.94,0,0,0-9.11,2.87c0,10.85.3,21.6,1.95,22.1,3.06.91,29.7-22.35,29.7-22.35s5.81,1.83,7,1.22.92-2.14,1.83-4.59S389.12,237.36,384.84,237.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.32,248.06c1.52-2.82-5.29-11.35-11.39-17.45a23.43,23.43,0,0,0-11,7.14c5.44,2.88,10.57,6,10.13,7.5-.92,3.07-15.57,17.59-15.57,17.59s-2.83-6.49-4.67-5.57-3.92,3.78-2.69,3.78,3.41,3.05,3.41,3.05,1.89,2,3.42,2S418.18,252,420.32,248.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47,385.69a3.83,3.83,0,0,0-4.33-.21c-.1,1.84-.46,10.08.63,12.79,1.23,3.06,4.59.61,4.9-4.29A25.81,25.81,0,0,0,414.47,385.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63,384.36c-1-.38-2.15-.3-3.1,1.47.27,5.61,5.35,14.29,8,12.26s-4.59-10.1-4.9-12.86A3.23,3.23,0,0,1,372.63,384.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.74,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.74,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.87,274.23s-4.67,13.66-5,15.46-7.16,24.57-8.66,39,.3,18.29,5.39,28.49,15.3,32.38,15.3,32.38l4.2-.3s-2.4-25.48-4.5-34.18-4.8-15.89-3.9-20.69,11.66-31.47,11.66-31.47,2.43,23.67,3.93,39.86,18.9,52.18,18.9,52.18l4.19-.6s.3-25.49-1.8-35.68-2.09-12.3-2.09-22.49-4.06-42.07-3.34-46.76c.81-5.31-1.19-12-1.19-12S283.07,279,275.87,274.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "284.73 293.76 290.4 302.88 278.69 296.48",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,280.47a7,7,0,0,0,.3,5.74,6.58,6.58,0,0,0,5.13,3.62s1.51,43.5,1.21,46.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,340.58s.31,4.54.31,8.16,5.13,17.52,5.13,24.47",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,255.87c-4.8-12.6-28.75-36.12-33-39.12s-12-2.7-12-2.7A22.74,22.74,0,0,1,274.2,206c-6.29-7.5-13.19-20.4-13.79-27.29s-1.8-24.89-1.8-24.89,3.3-7.8,3-10.2-4.5-4.8-7.5-2.7-4.5,4.8-3,8.1a14.52,14.52,0,0,1,1.5,5.4,119.89,119.89,0,0,0,1.2,37.18c3.9,19.49,13.82,32.39,16.52,37.18s4.94,39.49,4.94,44.29,2.1,6,10.79,6.6,21.14-.42,22.94-2.22.59-29.77.59-29.77,15.59,17.09,18.29,19.49S338.34,268.46,333.54,255.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,255.87c-4.8-12.6-28.75-36.12-33-39.12s-12-2.7-12-2.7A22.74,22.74,0,0,1,274.2,206a78.77,78.77,0,0,1-12-20.48l-9.11,2c.21,1.34.45,2.7.72,4.06,3.9,19.49,13.82,32.39,16.52,37.18s4.94,39.49,4.94,44.29,2.1,6,10.79,6.6,21.14-.42,22.94-2.22.59-29.77.59-29.77,15.59,17.09,18.29,19.49S338.34,268.46,333.54,255.87Z",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.78,256.75s-1.41-4.76-9.35-4.94-10.23,5.64-8.29,9.52,6.53,9.35,13.23,7.59S336.72,260.63,334.78,256.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,212.18s2.92.52,3.61,3.1a16.6,16.6,0,0,1-.17,8.25c-.69,1.89-3.27,6.71-3.27,6.71s-6.54-7.91-7.4-8.43-10,1.89-10,1.89,1.2-7.39,4-10.14S294.83,211.84,296.55,212.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,206.34s-1.89,6.7-1.89,9.28-7.91,12.56-7.91,12.56l-3.27-13.42,1.38-8.77S294.31,210.12,299,206.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,186.22s-.51,9.11-2.06,12.89-.34,9.81,3.44,12,9.46-.17,12.72-2.41,4.82-6.88,6.54-12,1.89-12.56-3.61-15S284.85,186.22,284.85,186.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.53,201.23s-.88-.29-1.76-2.92,1.76-2.93,1.76-6.15-2.93-7-7-5.86a27.5,27.5,0,0,1-14.64-.59c-3.81-1.46-2.34-10.54,5.56-12.3s4.69,3.81,7.91,3.81,8.49-3.22,10-.58-.3,4.39,2,5.56,4.09,2.05,4.09,5.86-5.27,12.59-5.27,12.59S304.29,204.16,302.53,201.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,203.07s2.23-4.47,4.3-3.61.69,3.26-1.55,5.16-3.61,1.2-3.61,1.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,251.55l-1.35-7.39a4.11,4.11,0,0,0,2.75-4.64l-1-5.52-8.13,1.49,1,5.52a4.13,4.13,0,0,0,4.22,3.37l1.35,7.38-4.06.74.24,1.31,9.29-1.7-.24-1.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.78,255.13s-3.7-.15-13.49-3.29c-8.94-2.88-11.54-5.44-13.84-6.48-1.67-.75-6.79-1.92-7.39-.12S294,247.3,294,247.3s.3.6,2.1,3.59,6,1.5,7.2,1.5,15.3,12.34,20.09,15,11.4.9,11.4-3.6S334.78,256,325.78,255.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.11,149.88s4.2-3.3,1.5-6.3-8.4.6-8.1,2.1,4.2,0,4.2,0-2.4,3-1.2,4.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23,394.92s-7.5,9-5.4,12.9,9-3.6,9.59-13.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,389.52s-10.2,3.3-10.2,8.4,12.3-4.2,14.4-8.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,181.57c-1.73-.22-10.6,1.36-10.6,3.57,0,1.23.53,5.11,1.76,5.47s10.58-1.41,11.11-1.94-.94-6.66-1.6-6.94A2.63,2.63,0,0,0,261.78,181.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.82,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.82,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.08,206.61s-3.63,7.51-3.63,10.62a16.29,16.29,0,0,0,.52,4.67l-9.59-9.07s3.63-8.29,3.89-9.85S212.08,206.61,212.08,206.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41,183.54a9.37,9.37,0,0,1,2.85,6.22c0,3.63,1,6.48,2.33,6.74s-.77,1.82-.77,1.82l-1,1.29s.52,6.74-2.33,9.07-13.22-4.4-13.22-4.4,0-4.15.52-11.67S208.45,182,214.41,183.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41,186.91a6.67,6.67,0,0,0,5.44-4.14c1.56-3.89.26-11.93-7.77-13s-3.89,3.63-8.81,5.44-13.22.52-16.59,7.52.78,15.8-.26,18.66-11.14,7-15.81,15,4.41,25.14,3.63,29.28-7,7.78-3.63,15.81,15.55,12.7,25.66,6,4.92-30.84.78-37.32,3.72-19.33,8.12-23.74,1.21-13.32,1.21-16.69S214.41,186.91,214.41,186.91Z",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.82,177.23s2.21,4.42-6.63,5.9-18,5.52-17.31,11.78.74,18.78-7.73,22.83-14.36,7-15.47,16.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.15,266.36s-5.15-7,1.48-16.58S187.78,234,194,224",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42,201.43a42,42,0,0,0,1.73-11.31c0-5.89,5.89-11.78,13.62-12.15s15.1-1.47,14.37-6.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12,268s-5.44,8.29-1,22.81,11.41,33.17,11.15,38.87-3.37,15.55-3.37,23.32-2.59,30.59-2.59,30.59l4.66,1.81s12.44-31.36,14.26-44.32,2.07-34.72,2.07-34.72,1.55-20.22-3.11-37.84C221.15,268.55,204.56,263.11,199.12,268Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.61,299.5s5.74,25.68,5.74,32.93-10,51.66-10,51.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.83,215.85c-1.14-1.15-4,1.71-4.43,3s.71,8.3.71,8.3-10.41,22-13.26,22.74-9.59-10.37-9.59-10.37l-.52,15s9.85,9.33,13.22,7.52,14-35.26,14-35.26a22.17,22.17,0,0,1,1.33-4.52C246.12,220.43,245,217,243.83,215.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,224.15s-1.72-5.15-1.72-6.73a34.51,34.51,0,0,1,.86-6.58c.43-1.58,1.72,0,1.72,1.43a34,34,0,0,1-.29,3.58s1.72,2.29,1.57,4.15l-.14,1.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,221.15,244.25,214a4,4,0,0,0,2.66-4.5l-1-5.35-7.88,1.45,1,5.35a4,4,0,0,0,4.09,3.26l1.31,7.16-3.94.72.23,1.26,9-1.65-.23-1.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.6,209.7a2.49,2.49,0,0,0-1.41-1.33c-.52-.17-1.06-.11-1.11.83-.1,1.89,1.16,10.37,1.45,8.51C246.78,216.06,248.51,211.66,247.6,209.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,211.26a2.46,2.46,0,0,0-1.41-1.33c-.52-.18-1.06-.12-1.11.83-.1,1.88,2.16,7.83,2.45,6C246.78,215.08,247.51,213.22,246.6,211.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,213.14a2.09,2.09,0,0,0-.86-.93c-.6-.34-1.5-.62-1.57.62-.1,1.88,2.06,7.09,2.35,5.23S247.39,215.19,246.38,213.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,214.93a2.46,2.46,0,0,0-1.41-1.33c-.52-.18-1-.11-1.1.83-.1,1.88,2.62,7.63,2.91,5.77A8.33,8.33,0,0,0,245.57,214.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,213.77a4.74,4.74,0,0,1,7.09-1.1c5.07,4.23,14.64,12.27,18,15.45,4.66,4.4,1,12.7,1,16.07s1.56,24.88,1.56,26.17-4.67,2.85-9.85,1.56S199.12,268,199.12,268s2.59-13,.52-17.1C197.82,247.29,187.26,224.58,193.72,213.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,269.58s-7,8-4.93,18.41,11.41,12.69,16.59,16.84,21.51,14.51,21.51,14.51-10.11,9.59-15.29,18.15-15,16.32-15,16.32l2.59,3.89s25.14-18.14,32.91-25.14,13-12.44,13-15S230,292.13,224,284.62A36.66,36.66,0,0,0,209.23,274",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.55,319.34a19.13,19.13,0,0,1,9.78-1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85,272s-3.93,8.76,0,14.2,32.93,28.7,35.35,29.9,3.92,2.42,2.41,4.23-35,35.05-35,35.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,220.34s-3.56-9.59-9.43-8.41c-8,1.59-6.38,38.22-8.45,39.25s-16.07-21.51-17.11-22.8.78-2.85-2.07-5.18-3.37-1.3-6.48-3.11-4.15-.78-3.89.51,4.67,2.85,4.67,2.85-5.7,0-8.29-.77-1,1-.26,2.33,5.7,3.37,7.51,3.37a23,23,0,0,1,4.67.78s8,19.69,11.92,24.88,8.81,13.73,13.22,9.07,11.14-34.47,11.14-34.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,232.32c-.82,9.3-1,18.36-2,18.86-2.08,1-13.83-16-16.1-23.4-.49-1.58-.23-2.25-3.08-4.59s-3.37-1.29-6.48-3.1-4.15-.78-3.89.51,4.67,2.85,4.67,2.85-5.7,0-8.29-.77-1,1-.26,2.33,5.7,3.37,7.51,3.37a23,23,0,0,1,4.67.78s8,19.69,11.92,24.88,8.81,13.73,13.22,9.07c2.63-2.8,6.1-14.58,8.47-23.61C195.63,234.7,192,232.87,189.17,232.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,383.62s-6.22,4.4-5.71,7,4.93,4.15,5.45,4.93,6.08,6.3,8.54,6.42,1.8-1.56.83-3.21-3.93-6.58-3.93-8.91a20.36,20.36,0,0,0-.52-4.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.23,353.81s-7.78.67-8.51.79-2.43,0-1.46,5.11.12,10.22,1.1,13.26,2.06,4,2.55,3.52,1.94-5.23,3.53-9.12a73.68,73.68,0,0,1,5.38-9.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,359.37l-.54-5.22c-2.09.18-4.33.39-4.71.45-.73.13-2.43,0-1.46,5.11s.12,10.22,1.1,13.26,2.06,4,2.55,3.52,1.94-5.23,3.53-9.12a55.69,55.69,0,0,1,3.62-6.87A11.41,11.41,0,0,0,199,359.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.45,389.84a18.78,18.78,0,0,0-.18-2.53l-3.66,1.6-4.55-2.6c-1.43,1.39-2.74,3.06-2.5,4.3.52,2.59,4.93,4.15,5.45,4.93s6.08,6.3,8.54,6.42,1.8-1.56.83-3.21S208.45,392.17,208.45,389.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.43,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#F33D3D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.43,
    cy: 397.68,
    rx: 45.82,
    ry: 9.84,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.83,269.78s-6.83,49-9.83,58-7,38-8.67,47a133.18,133.18,0,0,0-2,15l4.34,1.34s20.33-51,25.66-61.67A101.14,101.14,0,0,0,115,307.12s4,27,4,35.33,2.67,34.33,3.33,38.67,2,9.66,2,9.66l4-.66s6.34-36.67,7.34-55.34-2-45-4-53.66a86.52,86.52,0,0,0-3.84-13S107.33,272.78,97.83,269.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.46,
    y1: 307.19,
    x2: 124.92,
    y2: 286.95,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.97,
    y1: 304.17,
    x2: 124.32,
    y2: 296.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,213.12s-3.33.83-20.83,10.16-32.12,20.81-27.12,26.81,38.76,20.38,38.76,20.38l2.52-3.69s-26.28-17.19-26.28-20.52,22.12-10.14,22.12-10.14l7.66,33.66a30.24,30.24,0,0,0,15.17,2.5,35.19,35.19,0,0,0,14.83-4.16l2-34.67s20.84-3.33,26.67-15.17-2.17-40-2.17-40l-3.5.34s.34,27.33-2.5,32.5-25.5,1.5-34,.5S101,213.12,101,213.12Z",
    style: {
      fill: "#F33D3D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "102.56 233.78 90.17 236.12 100.15 238.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "130.06 225.32 129.83 233.45 134.89 221.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83,206.28s-2.83.5-3.5,3a16.08,16.08,0,0,0,.17,8c.67,1.84,3.17,6.5,3.17,6.5s6.29-6.22,7.24-6c4.65,1.06,7.25,1.51,9.67,2.12,0,0-1.25-9.61-3.91-12.27S103.5,206,101.83,206.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,200.62s1.83,6.5,1.83,9S109,221.78,109,221.78l3.17-13-1.34-8.5S104,204.28,99.5,200.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,181.12s.5,8.83,2,12.5.33,9.5-3.34,11.66-9.16-.16-12.33-2.33-4.67-6.67-6.33-11.67-1.84-12.16,3.5-14.5S113.17,181.12,113.17,181.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17,195.62s3.5-1.17,3.5-2.84-1.5-2.66-1.67-5.16,3.33-3.84,3.33-5.34a8.74,8.74,0,0,0-.33-2.5s7.83,2.84,12.5,2.84,5.67-3.84,4.33-4.84,2.84.67,1.17-2.83-9.83-6.17-17.83-3.83-9,5.83-9,5.83-6.84,3-6.34,7.83S93,195.45,93.67,196,95.17,195.62,95.17,195.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,197.45s-2.17-4.33-4.17-3.5-.66,3.17,1.5,5,3.5,1.17,3.5,1.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,178.62s-1.11-6.77-.69-8,3.17-4,4.28-2.9,2.2,4.42,1.38,6.21a21.7,21.7,0,0,0-1.29,4.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,175.72s-1.66-5-1.66-6.49a33.7,33.7,0,0,1,.83-6.35c.42-1.52,1.66,0,1.66,1.38a32.62,32.62,0,0,1-.28,3.45s1.66,2.21,1.52,4l-.14,1.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,172.82l-1.27-6.9a3.84,3.84,0,0,0,2.57-4.34l-.94-5.16-7.61,1.39.95,5.16a3.85,3.85,0,0,0,4,3.15l1.26,6.9-3.8.7.22,1.22,8.69-1.59-.22-1.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.87,161.78a2.37,2.37,0,0,0-1.37-1.28c-.5-.17-1-.11-1.06.8-.1,1.82,1.12,10,1.39,8.21C157.08,167.92,158.74,163.68,157.87,161.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,163.28a2.38,2.38,0,0,0-1.36-1.28c-.5-.17-1-.11-1.06.8-.1,1.82,2.08,7.56,2.35,5.77C157.08,167,157.78,165.18,156.9,163.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,165.1a2.1,2.1,0,0,0-.82-.9c-.59-.32-1.45-.59-1.52.6-.09,1.82,2,6.84,2.26,5S157.67,167.08,156.69,165.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,166.82a2.41,2.41,0,0,0-1.36-1.28c-.5-.17-1-.11-1.06.8-.1,1.82,2.53,7.36,2.81,5.57A8.12,8.12,0,0,0,155.91,166.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33,389.78s-6,7.67-6.33,12,9-2.33,10.67-10.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33,390.12s13.34,7.33,10.34,8.66-10.34-3.33-14.34-8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,266.78s8.8,1.2,8.8,3a2.77,2.77,0,0,1-1.36,2.49s-.68,1.58-4.07,2-5.89-3.85-5.89-3.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeleb);
export default __webpack_public_path__ + "static/media/celeb.49bdda0f55e1b762b8694c2c749317f3.svg";
export { ForwardRef as ReactComponent };